import React, { useEffect, useState, useRef } from "react";
import { Bar } from "react-chartjs-2";
import { Chart, CategoryScale, LinearScale, Title, BarElement, Tooltip } from "chart.js";
import { loadingCard } from "../../../helpers/loading";

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip);

interface InfractionsBarChartProps {
  data: any;
  isActive?: boolean;
}

export const InfractionsBarChart = ({ data, isActive = false }: InfractionsBarChartProps) => {
  const [current, setCurrent] = useState<any>();
  const chartRef = useRef<any>(null);

  useEffect(() => {
    if (data) {
      const { notes } = data;
      const infractions = notes?.infraction_type_counts?.filter((infraction: any) => infraction.infraction_type !== "banned");
      setCurrent(infractions);
    } else {
      setCurrent([]);
    }
  }, [data]);

  // Trigger a resize when the tab becomes active
  useEffect(() => {
    if (!isActive || !chartRef.current) return;
    const inst = chartRef.current?.chart || chartRef.current;
    if (typeof inst.resize === "function") inst.resize();
  }, [isActive]);

  if (!current) {
    return loadingCard();
  }

  const chartData = {
    labels: current?.length > 0 ? current?.map((item: any) => item.infraction_type) : ["No data available"],
    datasets: [
      {
        label: "Infractions",
        data: current?.map((item: any) => item.count),
        backgroundColor: ["#5D82A0"],
      },
    ],
  };

  const maxCount = current.length ? Math.max(...current.map((item: any) => item.count)) : 0;
  const maxCountWithBuffer = Math.ceil(maxCount / 5) * 5;

  const options = {
    indexAxis: "y" as const,
    maintainAspectRatio: false,
    datasets: {
      bar: {
        maxBarThickness: 30,
      },
    },
    scales: {
      x: {
        max: maxCountWithBuffer,
        ticks: {
          font: {
            size: 14,
          },
        },
      },
      y: {
        beginAtZero: true,
        max: maxCount + 50,
        ticks: {
          font: {
            size: 14,
          },
        },
      },
    },
    plugins: {
      title: {
        display: true,
        text: "Infractions By Type",
        color: "#5a7082",
        font: {
          size: 18,
          weight: 500,
        },
      },
      legend: {
        display: false,
      },
    },
    elements: {
      bar: {
        borderWidth: 1,
        borderRadius: 4,
        barPercentage: 0.8,
        categoryPercentage: 0.9,
      },
    },
  };

  return (
    <div style={{ height: `${chartData.labels.length * 50}px`, minHeight: "150px" }}>
      <Bar ref={chartRef} data={chartData} options={options} />
    </div>
  );
};
